import { useCurrencies } from 'uniswap/src/components/TokenSelector/hooks/useCurrencies'
import { GqlResult } from 'uniswap/src/data/types'
import { useEnabledChains } from 'uniswap/src/features/chains/hooks/useEnabledChains'
import { SUPPORTED_CHAIN_IDS } from 'uniswap/src/features/chains/types'
import { CurrencyInfo } from 'uniswap/src/features/dataApi/types'
import { buildNativeCurrencyId } from 'uniswap/src/utils/currencyId'

// Use only supported chains to avoid configuration errors
// Generate native currency IDs for all supported chains
// 只包含原生代币，其他代币从接口动态获取
const baseCurrencyIds = [
  // Native currencies for supported chains (只有 H2)
  ...SUPPORTED_CHAIN_IDS.map(chainId => buildNativeCurrencyId(chainId)),
]

export function useAllCommonBaseCurrencies(): GqlResult<CurrencyInfo[]> {
  const { isTestnetModeEnabled } = useEnabledChains()
  return useCurrencies(isTestnetModeEnabled ? [] : baseCurrencyIds)
}
